import React, { useCallback, useEffect, useMemo, useState } from "react"
import Screen from 'shared/Components/Skeleton/Screen';
import {
    Typography,
    createStyles,
    Theme,
    makeStyles,
    Dialog,
    Tab,
    Tabs,
    Grid,
    Divider,
    TableBody,
    TableRow,
    TableCell,
    IconButton,
    Table
} from "@material-ui/core"
import { IMyOrderDetails, IOrder, OrderType } from "shared/Types/appTypes"
import { connect, MapDispatchToPropsFunction, MapStateToProps, useSelector } from "react-redux"
import {IStoreState} from "../../../Reducers/rootReducer";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faCalendar } from "@fortawesome/pro-light-svg-icons/faCalendar"
import {Roboto} from "shared/theme";
import { getAllUpcomingMeetings, GetAllUpcomingMeetings } from "shared/Modules/Meeting/orderActions";
import {IOpenMeetingOptionsModal, openMeetingOptionsModal} from "../../../Actions/meetingOptionsModalActions";
import {IOpenMeetingDetailsModal, openMeetingDetailsModal} from "../../../Actions/meetingDetailsModalActions";
import { Localized } from '@fluent/react';
import { useDateTime } from 'shared/Modules/Localization/useDateTime'
import { MEETING_ORDER_MOCK, MEETING_ORDERS_MOCK } from "shared/Static/MeetingPlanning/deliveryForm"
import { useQuery } from "shared/Modules/Query/useQuery"
import { useToken } from "shared/Modules/Login/useToken"
import { selectCurrentEnvironment } from "shared/Modules/Environment/envSelectors"
import { DateTime } from "luxon"
import { useClock } from "shared/Modules/Time/useClock"
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers"
import LuxonUtils from "@date-io/luxon"
import { LocalizedStrict } from "shared/Modules/Localization/Components/Localized"
import clsx from "clsx"
import { PaymentMethodIcon } from "shared/Modules/Transaction/Components/PaymentMethodDrawer"
import { toDinero } from "shared/Helpers/CurrencyHelper"
import RightArrowIcon from "../../../Components/RightArrowIcon"
import { useMoney } from "shared/Modules/Localization/useMoney"
import DetailedMeetingReceiptModal from "shared/Modules/OrderDetails/Screens/DetailedMeetingReceiptModal"
import MyMeetingServiceOrdersData from "../../MyOrders/MyMeetingServiceOrdersData"
import DetailedResourceReceiptModal from "../../../../shared/Modules/OrderDetails/Screens/DetailedResourceReceiptModal"
import { getMetingServices } from "../../../../shared/Modules/OrderDetails/orderDetailsAPI"
import { getTranslationIdForEnum } from "shared/Modules/Localization/localizationLib";

enum TabType {
    MEETING_BOOKING = "MEETING_BOOKING",
    MEETING_SERVICE = "MEETING_SERVICE",
}

enum ActiveTab {
    MEETING_BOOKING = 0,
    MEETING_SERVICE = 1,
}

type TabDefinition = Readonly<{
    type: TabType
    orderTypes: Array<{
        type: OrderType
        enabled: boolean
    }>
}>

export interface IOwnProps {
    isOpen: boolean,
    onClose: () => void
}

interface IStateProps {
    upcomingMeetings: IOrder[] | null
    resourceBookingEnabled: boolean,
    showCateringModule: boolean
}

interface IDispatchProps {
    loadUpcomingMeetings: () => GetAllUpcomingMeetings
    showMeetingOptions: (order: IOrder) => IOpenMeetingOptionsModal
    showMeetingDetails: (order: IOrder) => IOpenMeetingDetailsModal
}
type Props =
    & IOwnProps
    & IStateProps
    & IDispatchProps

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        upcomingMeetingTitle: {
            color: '#505050',
            fontFamily: Roboto,
            fontSize: theme.typography.body1.fontSize,
            fontWeight: 900,
            letterSpacing: 0,
            lineHeight: '19px',
        },
        noPlannedMeetings: {
            color: '#505050',
            fontFamily: Roboto,
            fontSize: theme.typography.body1.fontSize,
            fontWeight: 400,
            letterSpacing: 0,
            lineHeight: '19px',
        },
        upcomingMeetingChip: {
            backgroundColor: '#48D793',
            marginLeft: 10,
            color: 'white',
            fontWeight: 400,
        },
        upcomingMeetingGreyText: {
            color: '#969696',
        },
        upcomingMeetingActions: {
            right: 0,
            bottom: 0,
            display: 'block',
            padding: '5px 7px',
            position: 'absolute',
            minWidth: 35,
            margin: '5px',
        },
        tabs: {
            borderBottom: "1px solid #e8e8e8",
        },
        datepickerContainer: {
            marginTop: theme.spacing(),
            marginBottom: 2,
        },
        datepicker: {
            maxWidth: 100,
        },
        resultAmount: {
            marginBottom: theme.spacing(4),
        },
        tableRow: {
            height: 48,
        },
        tableCell: {
            paddingTop: theme.spacing(1.5),
            paddingBottom: theme.spacing(1.5),
        },
        tableCellIcon: {
            width: theme.spacing(6),
            textAlign: "center",
            paddingRight: theme.spacing(1.5),
            "& .fa-xl": {
                fontSize: "1.75em",
            },
        },
        tableCellArrowIcon: {
            width: theme.spacing(5),
        },
        withoutBorderBottom: {
            borderBottom: "none",
        },
        greyColor: {
            color: theme.palette.grey[600],
        },
        totalText: {
            fontWeight: "bold",
        },
    }),
);

function getAvailableTabs(tabDefs: TabDefinition[]) {
    return tabDefs
        .filter((tab) => tab.orderTypes.some((t) => t.enabled))
        .map((tab) => ({
            type: tab.type,
            orderTypes: tab.orderTypes.filter((t) => t.enabled).map((t) => t.type),
        }))
}

const Home = ({ upcomingMeetings, loadUpcomingMeetings, resourceBookingEnabled, showCateringModule, showMeetingOptions, showMeetingDetails, isOpen,
                  onClose }: Props) => {
    const token = useToken()
    const environment = useSelector(selectCurrentEnvironment)
    const classes = useStyles();
    const dateTimeFactory = useDateTime()
    const moneyFactory = useMoney()
    const [tab, setTab] = useState(ActiveTab.MEETING_BOOKING)
    const { clock } = useClock({ resolution: "days" })
    const [startDate, setStartDate] = useState<DateTime>(clock.minus({ days: 7 }))
    const [endDate, setEndDate] = useState<DateTime>(clock)
    const [meetingReceiptOrder, setMeetingReceiptOrder] = useState<IMyOrderDetails>()

    const [resourceBookings, setResourcesBookings] = useState<IOrder[] | null>(null)

    const { QueryPane } = useQuery(
        () => getMetingServices(token, environment, startDate.toISODate(), endDate.toISODate()),
        [token, environment, startDate, endDate],
    )

    const tabDefinitions: TabDefinition[] = [
        {
            type: TabType.MEETING_BOOKING,
            orderTypes: [
                { type: OrderType.RESOURCE_BOOKING, enabled: resourceBookingEnabled },
            ],
        },
        {
            type: TabType.MEETING_SERVICE,
            orderTypes: [
                { type: OrderType.MEETING, enabled: showCateringModule },
            ],
        },
    ]

    const availableTabs = useMemo(() => {
        return getAvailableTabs(tabDefinitions)
    }, [tabDefinitions, getAvailableTabs])

    const renderUpcomingMeetings = useMemo(() => {
        if (!resourceBookings?.length) {
            return (
                <Localized id="my-meetings-no-meetings-label">
                    <Typography gutterBottom={true} variant="h5" component="h3" className={classes.noPlannedMeetings}>
                        Ingen planlagte møder
                    </Typography>
                </Localized>
            );
        }

        return (
            <div>
                {!resourceBookings?.length ? <Localized id="my-meetings-no-filtered-label">
                    <Typography gutterBottom={true} variant="h5" component="h3" className={classes.upcomingMeetingTitle}>
                        Ingen møder matcher din søgning
                    </Typography>
                </Localized> : <>
                    <LocalizedStrict id="my-orders-results" vars={{ amount: resourceBookings.length }}>
                        <Typography component="p" variant="caption" color="textSecondary" className={classes.resultAmount}>
                            {`${resourceBookings.length} resultater`}
                        </Typography>
                    </LocalizedStrict>

                    <Divider />
                    <Table padding="none" cellPadding="none">
                        <TableBody>
                            {resourceBookings.map((order, index) => (
                                <TableRow key={index} className={classes.tableRow} onClick={() => setMeetingReceiptOrder({
                                    ...MEETING_ORDER_MOCK,
                                    id: order.id,
                                    displayName: `GoPay #${order.id}`,
                                })}>
                                    <TableCell className={clsx(classes.tableCell, classes.tableCellIcon)}>
                                        <PaymentMethodIcon iconDetails={{
                                            "type": "IMAGE_URL",
                                            "url": "https://facilitynet.dk/remote/gopay/payment-icons/payroll.svg"
                                        }} />
                                    </TableCell>
                                    <TableCell className={classes.tableCell}>
                                        <Typography variant="body2">
                                            {order.meetingDetails?.startDateTime ? dateTimeFactory.formatDate(
                                                dateTimeFactory.fromISO(order.meetingDetails.startDateTime.replace(' ', 'T'))
                                            ) : order.meetingDetails?.meetingTimeAsText}
                                        </Typography>
                                        <Typography variant="body2" className={classes.greyColor}>
                                            {order.meetingDetails?.meetingName}
                                        </Typography>
                                    </TableCell>
                                    <TableCell align="right" className={classes.tableCell}>
                                        <Typography>{moneyFactory.formatAsNumber(toDinero({
                                            amount: 10000,
                                            currency: "DKK",
                                            scale: 2,
                                        }))}</Typography>
                                    </TableCell>
                                    <TableCell align="right" className={clsx(classes.tableCell, classes.tableCellArrowIcon)}>
                                        <IconButton>
                                            <RightArrowIcon />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}

                            <TableRow>
                                <TableCell className={clsx([classes.tableCell, classes.withoutBorderBottom])} />
                                <TableCell className={clsx([classes.tableCell, classes.withoutBorderBottom])}>
                                    <LocalizedStrict id="my-orders-price-total">
                                        <Typography className={classes.totalText}>Total</Typography>
                                    </LocalizedStrict>
                                </TableCell>
                                <TableCell align="right" className={clsx([classes.tableCell, classes.withoutBorderBottom])}>
                                    <Typography>
                                        <strong>{moneyFactory.formatAsNumber(toDinero({
                                            amount: 10000 * resourceBookings.length,
                                            currency: "DKK",
                                            scale: 2,
                                        }))}</strong>
                                    </Typography>
                                </TableCell>
                                <TableCell className={clsx([classes.tableCell, classes.withoutBorderBottom])} />
                            </TableRow>
                        </TableBody>
                    </Table>
                    {meetingReceiptOrder && (
                        <DetailedResourceReceiptModal
                            order={meetingReceiptOrder}
                            open={meetingReceiptOrder !== undefined}
                            onClose={() => setMeetingReceiptOrder(undefined)}
                        />
                    )}
                </>}
            </div>
        );
    }, [resourceBookings, meetingReceiptOrder]);

    useEffect(() => {
        // Fetch upcoming meetings
        loadUpcomingMeetings();
    }, [isOpen]);

    useEffect(() => {
        if (!upcomingMeetings) {
            setResourcesBookings(null)
            return
        }

        if (endDate || startDate) {
            const filtered = upcomingMeetings.filter((item) => {
                const meetingStart = item.meetingDetails?.startDateTime?.split(' ')[0];
                const meetingEnd = item.meetingDetails?.endDateTime?.split(' ')[0];
                if (meetingStart && meetingEnd) {
                    return meetingStart >= startDate.toFormat('yyyy-LL-dd') && meetingEnd <= endDate.toFormat('yyyy-LL-dd');
                }

                return item
            });

            setResourcesBookings(filtered);

            return
        }

        setResourcesBookings(upcomingMeetings)
    }, [upcomingMeetings, startDate, endDate])

    const handleTabChange = useCallback((selectedTab: number) => {
        setTab(selectedTab)
    }, [setTab])

    const handleStartDateChange = useCallback((date: any)  => {
        date = date as DateTime
        setStartDate(date)
        if (endDate && date.toMillis() > endDate?.toMillis()) {
            setEndDate(date)
        }
    }, [endDate, setStartDate])

    const handleEndDateChange = useCallback((date: any) => {
        date = date as DateTime
        setEndDate(date)
        if (startDate && startDate.toMillis() > date.toMillis()) {
            setStartDate(date)
        }
    }, [startDate, setStartDate])

    return (
        <Dialog fullScreen open={isOpen}>
            <Localized id="my-meetings-header-label" attrs={{primaryTopBarTitle: true}}>
                <Screen
                    name='MyMeetings'
                    backButtonIcon='back'
                    primaryTopBarTitle='Mine møder'
                    onBackButtonPress={onClose}
                    showHeaderSection
                    headerIcon={faCalendar}
                >
                    <Grid container direction="column" spacing={2} wrap="nowrap">
                        <Grid item>
                            <Tabs value={tab} indicatorColor="primary" className={classes.tabs}>
                                {availableTabs.map((availableTab, index) => (
                                    <Localized
                                        key={index}
                                        id={getTranslationIdForEnum("my-meetings-tab", availableTab.type)}
                                        attrs={{ label: true }}
                                    >
                                        <Tab label={availableTab.type} onClick={() => handleTabChange(index)} />
                                    </Localized>
                                ))}
                            </Tabs>
                        </Grid>
                        <Grid item>
                            <MuiPickersUtilsProvider utils={LuxonUtils}>
                                <Grid
                                    container
                                    spacing={1}
                                    wrap="nowrap"
                                    alignItems="center"
                                    className={classes.datepickerContainer}
                                >
                                    <Grid item>
                                        <FontAwesomeIcon icon={faCalendar} size="lg" />
                                    </Grid>
                                    <Grid item>
                                        <DatePicker
                                            className={classes.datepicker}
                                            value={startDate}
                                            onChange={handleStartDateChange}
                                            size="small"
                                            labelFunc={(d) => dateTimeFactory.formatDate(d ?? dateTimeFactory.now())}
                                        />
                                    </Grid>
                                    <Grid item>
                                        <span>-</span>
                                    </Grid>
                                    <Grid item>
                                        <DatePicker
                                            className={classes.datepicker}
                                            value={endDate}
                                            onChange={handleEndDateChange}
                                            size="small"
                                            labelFunc={(d) => dateTimeFactory.formatDate(d ?? dateTimeFactory.now())}
                                        />
                                    </Grid>
                                </Grid>
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item>
                            {tab === ActiveTab.MEETING_BOOKING ? renderUpcomingMeetings :
                                <QueryPane>
                                    {(data) => <MyMeetingServiceOrdersData initialData={data.orders} token={token} environment={environment} />}
                                </QueryPane>
                            }
                        </Grid>
                    </Grid>
                </Screen>
            </Localized>
        </Dialog>
    )
};

const mapStateToProps: MapStateToProps<IStateProps, IOwnProps, IStoreState> = ({ allUpcomingMeetings, properties }) => ({
    upcomingMeetings: allUpcomingMeetings.upcomingMeetings,
    resourceBookingEnabled: properties.showResourceBookingModule,
    showCateringModule: properties.showCateringModule,
});

const mapDispatchToProps: MapDispatchToPropsFunction<IDispatchProps, IOwnProps> = (dispatch) => ({
    loadUpcomingMeetings: () => {
        return dispatch(getAllUpcomingMeetings());
    },
    showMeetingOptions: (order: IOrder) => {
        return dispatch(openMeetingOptionsModal(order));
    },
    showMeetingDetails: (order: IOrder) => {
        return dispatch(openMeetingDetailsModal(order));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(Home)
